import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import '../../css/settingOutlet.css';
import { HomeIcon, SettingBreadcrumbIcon } from '../../../../../asset-controller-mod/asset-serv/icons/iconExporter';
import SettingHeadNav from '../../../header/ts/settingHeadNav';
import ButtonDecision from './button-decision';
import { SettingsDraftProvider } from '../../../../../context-controller-mod/context-serv/global-provider/setting-context/settings-draft.context';

const SettingOutlet: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="scl--setting-outlet-root">

      {/* ── Breadcrumb ── */}
      <div className="scl--setting-outlet-breadcrumb">
        <button
          type="button"
          className="scl--setting-outlet-breadcrumb-home"
          onClick={() => navigate('/overview')}
        >
          <HomeIcon />
          <span>Home</span>
        </button>
        <span className="scl--setting-outlet-breadcrumb-sep">/</span>
        <span className="scl--setting-outlet-breadcrumb-icon"><SettingBreadcrumbIcon /></span>
        <span className="scl--setting-outlet-breadcrumb-current">Setting</span>
      </div>

      <h1 className="scl--setting-outlet-title">Setting</h1>

      <SettingHeadNav/>
      
      <SettingsDraftProvider>
        <div className="scl--setting-outlet-content">
          <Outlet />
        </div>

        <ButtonDecision/>
      </SettingsDraftProvider>

    </div>
  );
};

export default SettingOutlet;